import { render, staticRenderFns } from "./FiscalCodeBarcode.vue?vue&type=template&id=885d1004&scoped=true&"
import script from "./FiscalCodeBarcode.vue?vue&type=script&lang=js&"
export * from "./FiscalCodeBarcode.vue?vue&type=script&lang=js&"
import style0 from "./FiscalCodeBarcode.vue?vue&type=style&index=0&id=885d1004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885d1004",
  null
  
)

export default component.exports